// import { shoptourApi } from 'yxt-biz-pc/packages/api';
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';

// 查询区域树
export const getModuleList = (offset, limit, data) => {
  return apiBaseUrl.post(
    `/sdproject/supplier/orgSupplier/moduleList?offset=${offset}&limit=${limit}`,
    data,
    {
      headers: {
        token: window.localStorage.getItem('token'),
        orgId: window.localStorage.getItem('orgId')
      }
    }
  );
};
